import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { updateMemberStatusAPI } from 'api/members'
import {
  MemberStatusUpdateFormTypes,
  MemberStatusUpdateFormSubmitValuesTypes,
  MemberStatusUpdateFormSubmitActionsTypes,
  MemberStatuses,
} from 'types/member'
import { MemberDetail } from 'types/member'
import { MerchantProfileTypes } from 'types/merchant'
import useMemberStore from 'store/member'
import useMerchantStore from 'store/merchant'

const UPDATESTATUSINITVAL: MemberStatusUpdateFormTypes = {
  newStatusId: undefined,
}

export const useProfileUpdate = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  merchant: MerchantProfileTypes | undefined
  memberStatuses: MemberStatuses[]
  isLoading: boolean
  initialValues: MemberStatusUpdateFormTypes
  handleSubmitStatusUpdate: (
    values: MemberStatusUpdateFormSubmitValuesTypes,
    actions: MemberStatusUpdateFormSubmitActionsTypes
  ) => void
  handleClearProfileUpdate: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const member = useMemberStore((state) => state.member)
  const merchant = useMerchantStore((state) => state.merchantProfile)
  const getMerchantProfile = useMerchantStore(
    (state) => state.getMerchantProfile
  )
  const memberStatuses = useMemberStore((state) => state.memberStatuses);
  const getMemberStore = useMemberStore((state) => state.getMember)
  const getMemberStatuses = useMemberStore((state) => state.getMemberStatuses)
  const [initialValues, initialValuesSet] =
    useState<MemberStatusUpdateFormTypes>({
      ...UPDATESTATUSINITVAL,
      newStatusId: merchant[0]?.memberThorStatusId,
    })
  const queryClient = useQueryClient()

  useEffect(() => {
    getMemberStatuses(String(traderId))
  }, [])

  const handleSubmitStatusUpdate = useCallback(
    async (
      values: MemberStatusUpdateFormSubmitValuesTypes,
      actions: MemberStatusUpdateFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        // if status is not cancelled / terminated
        await updateMemberStatusAPI({
          traderId: String(traderId),
          newStatusId: String(values.newStatusId),
        })
        await getMerchantProfile(String(traderId))
        await getMemberStore(String(traderId))
        // initialValuesSet(values)
        queryClient.invalidateQueries({ queryKey: ['useMemberProfiles'] })
        toast.success('Merchant status update successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        // const message = JSON.parse(JSON.stringify(error))
        toast.error(`Merchant status update error.`)
      }
      isLoadingSet(false)
    },
    [isLoadingSet, getMemberStore, initialValuesSet, updateMemberStatusAPI]
  )

  const handleClearProfileUpdate = useCallback(() => {
    initialValuesSet({ ...UPDATESTATUSINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    merchant: merchant?.[0],
    memberStatuses,
    isLoading,
    initialValues,
    handleSubmitStatusUpdate,
    handleClearProfileUpdate,
  }
}
